// Dawn (and most themes) sometimes apply overflow-x: hidden/clip to a
// wrapper element to prevent horizontal scroll from full-bleed
// sections. Any ancestor with overflow other than "visible" silently
// breaks position: sticky for everything nested inside it — with no
// error, it just quietly stops sticking. Walk up from the sidebar and
// force any such ancestor back to visible so sticky can actually work.
(function () {
  var sidebar = document.querySelector('[data-sidebar-sticky]');
  if (!sidebar) return;

  var el = sidebar.parentElement;
  while (el && el !== document.body) {
    var style = window.getComputedStyle(el);
    if (style.overflowX !== 'visible' || style.overflowY !== 'visible') {
      el.style.overflow = 'visible';
    }
    el = el.parentElement;
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  var content = document.querySelector('[data-article-content]');
  var toc = document.querySelector('[data-article-toc]');
  var tocList = document.querySelector('[data-toc-list]');

  if (content && toc && tocList) {
    var headings = content.querySelectorAll('h2');

    if (headings.length > 0) {
      var links = [];

      var indicator = document.createElement('span');
      indicator.className = 'custom-article__toc-indicator';
      indicator.setAttribute('data-toc-indicator', '');
      tocList.appendChild(indicator);

      headings.forEach(function (heading, index) {
        if (!heading.id) {
          var slug = heading.textContent
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-');
          heading.id = slug || 'section-' + index;
        }

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent;
        li.appendChild(a);
        tocList.insertBefore(li, indicator);
        links.push({ link: a, item: li, heading: heading });
      });

      toc.hidden = false;

      function moveIndicatorTo(item) {
        var top = item.offsetTop + item.offsetHeight / 2 - 4;
        indicator.style.top = top + 'px';
        indicator.classList.add('is-visible');
      }

      // Scrollspy: highlight whichever heading's section is currently
      // in view as the user scrolls through the article, and slide
      // the dot indicator to match it.
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var match = links.find(function (item) {
              return item.heading === entry.target;
            });
            if (!match) return;
            if (entry.isIntersecting) {
              links.forEach(function (item) {
                item.link.classList.remove('is-active');
              });
              match.link.classList.add('is-active');
              moveIndicatorTo(match.item);
            }
          });
        },
        { rootMargin: '-20% 0px -70% 0px' }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });

      // Set an initial position so the dot isn't sitting at 0 before
      // the first scroll-triggered intersection fires.
      if (links.length > 0) {
        links[0].link.classList.add('is-active');
        moveIndicatorTo(links[0].item);
      }

      // If the URL already had a #fragment when the page loaded (e.g.
      // from clicking a TOC link elsewhere, or a bookmarked section
      // link), the browser tries to jump to it immediately — before
      // these heading IDs existed yet, so that jump silently fails.
      // Do it manually now that the IDs are in place.
      if (window.location.hash) {
        var targetId = window.location.hash.slice(1);
        var target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }
    }
  }

  // Copy-link button
  var copyBtn = document.querySelector('[data-copy-link]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var url = copyBtn.getAttribute('data-copy-link');
      if (!url) return;

      navigator.clipboard
        .writeText(url)
        .then(function () {
          copyBtn.classList.add('is-copied');
          setTimeout(function () {
            copyBtn.classList.remove('is-copied');
          }, 1500);
        })
        .catch(function () {
          // Clipboard API unavailable — fail silently, link sharing
          // via the other icons still works.
        });
    });
  }
});